<template>
  <div class="home-first-screen">
    <v-nav/>
    <h1 class="home-description">
      人脑功能图谱可视化
      <div class="sub-title">Visualizing the functional mapping of human brain</div>
      <div style="width: 300px;margin-top: 20px">
        <a-button class="main-btn" type="primary" shape="round" size="large" @click="gotoPage('/standard/surface')">标准脑</a-button>
        <a-button class="main-btn" type="primary" shape="round" size="large" @click="gotoPage('/standard/surface')">个体脑</a-button>
      </div>
    </h1>
    <div class="brain-container">
      <zi-brain :rotation="true"></zi-brain>
    </div>
    <div class="home-footer">
      <img class="logo-img" @click="gotoWebsite('https://www.bjni.org.cn/')" src="../../assets/logo/sjyjs.jpg"/>
      <img class="logo-img" @click="gotoWebsite('http://bjtth.54doctor.net/')" src="../../assets/logo/ttyy.png"/>
      <img class="logo-img" @click="gotoWebsite('https://www.cibr.ac.cn/')" src="../../assets/logo/cibr.png"/>
    </div>
  </div>
</template>

<script>
import VNav from "@/components/public/VNav";
import ZiBrain from "@/components/test/ziBrain.vue";

export default {
  name: "ziHome",
  components: {ZiBrain, VNav},
  data() {
    return {
      selectedKeys: ["fafact"],
    }
  },
  methods: {
    gotoWebsite(url) {
      window.open(url, '_blank')
    },
    gotoPage(url) {
      this.$router.push(url)
    }
  }
}
</script>

<style scoped>
.home-first-screen {
  width: 100%;
  height: 100vh;
  /*background-color: #320e41;*/

}

.brain-container {
  width: 50%;
  height: 70%;
  position: absolute;
  right: 5%;
  top: 10%;
  overflow: hidden;
  border: 1px solid white;
}

/* 公共基础样式 */
.demo {
  width: 300px;
  height: 150px;
  background-color: #14274F;
  color: rgb(255, 255, 255, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 50px;
}

/* 凸起效果样式 */
.brain-up {
  border-left: 1px solid #33B8EC;
  border-top: 1px solid #33B8EC;
  border-right: 3px solid #000;
  border-bottom: 3px solid #000;
}

/* 凹陷效果样式 */
.brain-down {
  border-right: 1px solid #33B8EC;
  border-bottom: 1px solid #33B8EC;
  border-left: 3px solid #000;
  border-top: 3px solid #000;
}

.home-description {
  position: absolute;
  left: 5%;
  top: 25%;
  font-size: 2.5rem;
  font-weight: bold;
  color: white;
}

.sub-title {
  font-size: 1.0rem;
  font-weight: normal;

}

.standard-brain {
  background-image: url("../../assets/standard.png");
}

.personal-brain {
  background-image: url("../../assets/personal.png");
}

.brain-button {
  background-repeat: no-repeat;
  background-size: contain;
  height: 100px;
  width: 100px;
  display: inline-block;
  cursor: pointer;
  font-size: 1rem;
  line-height: 100px;
  text-align: center;
}

.home-footer {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  text-align: center;
  height: 80px;
  padding: 20px 0;
  border-top: 1px solid white;
}

.logo-img {
  height: 100%;
  margin-left: 20px;
  cursor: pointer;
}
.main-btn{
  margin: 20px 20px;
}
</style>